import barrierService from "../../../../services/BarrierService";
import _ from "lodash";
import { barrierActions } from "./reducer";

// barrier log thunk
const getLogFilterDataThunk = () => async dispatch => {
  try {
    const response = await barrierService.getFilterLogData();
    if (_.get(response, "data.success")) {
      const {
        direction,
        open_type,
        stations,
        station_gates,
        recognize_type,
        camera_type
      } = _.get(response, "data.data", {
        direction: {},
        open_type: {},
        stations: [],
        station_gates: [],
        recognize_type: {},
        camera_type: {}
      });
      dispatch(
        barrierActions.getLogFilterDataSucceed({
          direction,
          open_type,
          stations,
          station_gates,
          recognize_type,
          camera_type
        })
      );
    } else {
      dispatch(barrierActions.getLogFilterDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getLogFilterDataFailed());
  }
};

const getLogThunk = params => async dispatch => {
  try {
    const response = await barrierService.getLogs(params);
    if (_.get(response, "data.success")) {
      dispatch(barrierActions.getLogDataSucceed(_.get(response, "data")));
    } else {
      dispatch(barrierActions.getLogDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getLogDataFailed());
  }
};
const getHumanLogThunk = params => async dispatch => {
  try {
    const response = await barrierService.getHumanLogs(params);
    if (_.get(response, "data.success")) {
      dispatch(barrierActions.getHumanLogDataSucceed(_.get(response, "data")));
    } else {
      dispatch(barrierActions.getHumanLogDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getHumanLogDataFailed());
  }
};

// barrier camera thunk
const getCameraThunk = params => async dispatch => {
  try {
    const response = await barrierService.getCameras(params);
    if (_.get(response, "data.success")) {
      dispatch(barrierActions.getCameraDataSucceed(_.get(response, "data")));
    } else {
      dispatch(barrierActions.getCameraDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getCameraDataFailed());
  }
};

const deleteCameraThunk = id => async dispatch => {
  try {
    const response = await barrierService.deleteCamera(id);
    if (_.get(response, "data.success")) {
      dispatch(barrierActions.deleteCameraSucceed(_.get(response, "data")));
    } else {
      dispatch(barrierActions.deleteCameraFailed());
    }
  } catch (e) {
    dispatch(barrierActions.deleteCameraFailed());
  }
};

const getStationThunk = () => async dispatch => {
  try {
    const response = await barrierService.getStations();
    if (_.get(response, "data.success")) {
      dispatch(barrierActions.getStationDataSucceed(_.get(response, "data")));
    } else {
      dispatch(barrierActions.getStationDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getStationDataFailed());
  }
};

const getGateByStationIdThunk = stationId => async dispatch => {
  try {
    const response = await barrierService.getGateByStationId(stationId);
    if (_.get(response, "data.success")) {
      dispatch(barrierActions.getGateDataSucceed(_.get(response, "data")));
    } else {
      dispatch(barrierActions.getGateDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getGateDataFailed());
  }
};

const getDashboardThunk = (stationId, date) => async dispatch => {
  try {
    const response = await barrierService.getDashboardData(stationId, date);
    if (_.get(response, "data.success")) {
      dispatch(barrierActions.getDashboardDataSucceed(_.get(response, "data")));
    } else {
      dispatch(barrierActions.getDashboardDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getDashboardDataFailed());
  }
};

const getDashboardFilterDataThunk = () => async dispatch => {
  try {
    const response = await barrierService.getFilterDashboardData();
    if (_.get(response, "data.success")) {
      const { direction, stations, recognize_type } = _.get(
        response,
        "data.data",
        {
          directions: [],
          direction: {},
          stations: [],
          recognize_type: {},
          recognize_types: []
        }
      );
      dispatch(
        barrierActions.getFilterDashboardDataSucceed({
          directions: Object.keys(direction),
          direction,
          stations,
          recognize_type,
          recognize_types: Object.keys(recognize_type)
        })
      );
    } else {
      dispatch(barrierActions.getFilterDashboardDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getFilterDashboardDataFailed());
  }
};

const getGatesThunk = params => async dispatch => {
  try {
    const response = await barrierService.getListGate(params);
    if (_.get(response, "data.success")) {
      dispatch(barrierActions.getGateDataSucceed(_.get(response, "data")));
    } else {
      dispatch(barrierActions.getGateDataFailed());
    }
  } catch (e) {
    dispatch(barrierActions.getGateDataFailed());
  }
};

export const barrierThunks = {
  getLogFilterDataThunk,
  getLogThunk,
  getHumanLogThunk,
  getCameraThunk,
  deleteCameraThunk,
  getStationThunk,
  getGateByStationIdThunk,
  getDashboardThunk,
  getDashboardFilterDataThunk,
  getGatesThunk
};
